export default __webpack_public_path__ + "static/media/snakesHearing.cf0c2a4b.jpeg";